/**
 * 状态计数卡片 —— 标签文字、图标、颜色三者全部取自 STATUS_MAP，
 * 因此任何页面都不可能出现「生效中配了黄色」这类漂移：
 * 状态映射改了，这里跟着改；映射缺项，启动时 tokens.ts 就抛错。
 */
import { Link } from 'react-router-dom';
import { Icon } from '../../icons/Icon';
import { cssVar, ICON_SIZE, statusOf } from '../../tokens';
import type { AnyStatus } from '../../tokens';
import { formatCount } from '../../lib/format';

export interface StatusMetricCardProps {
  readonly status: AnyStatus;
  readonly value: number;
  readonly hint: string;
}

export function StatusMetricCard({ status, value, hint }: StatusMetricCardProps) {
  const descriptor = statusOf(status);

  return (
    <div className="card">
      <div className="metric__label">
        <span style={{ color: cssVar(descriptor.token), display: 'inline-flex' }}>
          <Icon name={descriptor.icon} size={ICON_SIZE.inline} />
        </span>
        {descriptor.label}
      </div>
      <div className="metric__value">{formatCount(value)}</div>
      <div className="metric__hint">
        {hint}
        {' · '}
        <Link to={`/licenses?status=${descriptor.value}`} className="link-button">
          查看列表
        </Link>
      </div>
    </div>
  );
}
